import { ChangeEvent } from 'react';
import { Checkbox } from '@material-ui/core';
import { ErrorMessage, FormLabel } from '../helpers';
import ListBase, { ListProps } from './ListBase';

export interface CheckboxListProps<T> extends ListProps<T> {
    name?: string;
    label?: string;
    setFieldValue?: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
    values?: T[];
    onChange?: (event: ChangeEvent, checked: boolean, value: T, newValues: T[]) => void;
}

export default <T extends any>(props: CheckboxListProps<T>) => {
    const { name, label, setFieldValue, options, values, onChange, ...baseProps } = props;

    return <>
        <FormLabel label={label} />
        <ListBase
            {...baseProps}
            options={options.map(({ disabled, value, ...option }) => ({
                ...option,
                control: <Checkbox
                    color="primary"
                    checked={values?.includes(value)}
                    disabled={disabled}
                    onChange={e => {
                        const checked = e.currentTarget.checked;
                        const newValues = checked ? values?.concat(value) || [value] : values?.filter(v => v !== value) || [];
                        name && setFieldValue && setFieldValue(name, newValues, true);
                        onChange && onChange(e, checked, value, newValues);
                    }}
                />
            }))}
        />
        <ErrorMessage name={name} />
    </>
}
